<template>
    <div class="vx-col w-full">
    <div  v-if="value">
        <h3 class="small-header">Affidavit Information</h3>
            <div class="form-container"> 
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="vx-row" >
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false" :tplsection="tplsection" :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'currentAnnualSalary'+cid" :formscope="formscope" v-model="value.currentAnnualSalary" :required="true" :fieldName="'currentAnnualSalary'+fieldName" label="Current annual salary ($)" placeHolder="Current annual salary" :tplkey="'currentAnnualSalary'"/>
                    <immiInput :notRequired="notRequired" :display="false" :tplsection="tplsection" :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'nameOfEmployer'+cid " :formscope="formscope" v-model="value.nameOfEmployer" :required="true" :fieldName="'nameOfEmployer'+fieldName " label="Name of the employer" placeHolder="Name of the employer" :tplkey="'nameOfEmployer'"/>
                    <immiInput :notRequired="notRequired" :display="false" :tplsection="tplsection" :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'currentPosition'+cid " :formscope="formscope" v-model="value.currentPosition" :required="true" :fieldName="'currentPosition' +fieldName" label="Current Position" placeHolder="Current Position" :tplkey="'currentPosition'"/>
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'depositsInBankUSA'+cid " :formscope="formscope" v-model="value.depositsInBankUSA" :required="true" :fieldName="'depositsInBankUSA'+fieldName " label="Deposits in Bank ($)" placeHolder="Deposits in Bank" :tplkey="'depositsInBankUSA'"/>
                    <template v-if="value.depositsInBankUSA">
                      <div class="vx-col w-full quest_485_v2">
                          <casedocumentslist :showTitle="false" :tplsection="tplsection" :docslist="benfAdjustmentDocument" :formscope="formscope" :fieldsArray="fieldsArray" v-model="value" :fieldName="'benfAdjustmentDocument'"></casedocumentslist>
                      </div>
                    </template> 
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'reasonableValPersonalProperty'+cid " :formscope="formscope" v-model="value.reasonableValPersonalProperty" :required="true" :fieldName="'reasonableValPersonalProperty'+fieldName " label="Reasonable value of personal property" placeHolder="Reasonable value of personal property" :tplkey="'reasonableValPersonalProperty'"/>
                    <!-- <immiyesorno :notRequired="notRequired" wrapclass=" " :required="checkFieldIsRequired({'key':'haveMarketValInStocksAndBonds','section':tplsection, 'fieldsArray':fieldsArray, 'required':true,'notRequired':notRequired })" :tplkey="'haveMarketValInStocksAndBonds'"  :display="false" :fieldsArray="fieldsArray" :formscope="formscope" cid="haveMarketValInStocksAndBonds"  v-model="value.haveMarketValInStocksAndBonds" :tplsection="tplsection"  :fieldName="'haveMarketValInStocksAndBonds'+fieldName"  label="Do you have bonds and stocks"></immiyesorno> -->
                    <immiInput :maxLength="25" :onlyNumbers="true"  :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'marketValInStocksAndBonds'+cid " :formscope="formscope" v-model="value.marketValInStocksAndBonds" :required="true" :fieldName="'marketValInStocksAndBonds'+fieldName " label="Market value of bonds and stocks, if any" placeHolder="Market value of bonds and stocks" :tplkey="'marketValInStocksAndBonds'"/>
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'sumOfLifeInsurance'+cid " :formscope="formscope" v-model="value.sumOfLifeInsurance" :required="true" :fieldName="'sumOfLifeInsurance'+fieldName " label="Sum of Life Insurance" placeHolder="Sum of Life Insurance" :tplkey="'sumOfLifeInsurance'"/>
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'cashSurrValOfLifeInsurance'+cid " :formscope="formscope" v-model="value.cashSurrValOfLifeInsurance" :required="true" :fieldName="'cashSurrValOfLifeInsurance'+fieldName " label="Cash surrender value of Life Insurance" placeHolder="Cash surrender value of Life Insurance" :tplkey="'cashSurrValOfLifeInsurance'"/>
                    <!-- <immiyesorno :notRequired="notRequired" wrapclass=" " :required="checkFieldIsRequired({'key':'haveValOfRealEstate','section':tplsection, 'fieldsArray':fieldsArray, 'required':true,'notRequired':notRequired })" :tplkey="'haveValOfRealEstate'"  :display="false" :fieldsArray="fieldsArray" :formscope="formscope" cid="haveValOfRealEstate"  v-model="value.haveValOfRealEstate" :tplsection="tplsection"  :fieldName="'haveValOfRealEstate'+fieldName"  label="Do you owned Real Estate"></immiyesorno> -->
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'valOfRealEstate'+cid " :formscope="formscope" v-model="value.valOfRealEstate" :required="true" :fieldName="'valOfRealEstate'+fieldName " label="Value of Real Estate, if owned" placeHolder="Value of Real Estate" :tplkey="'valOfRealEstate'"/>
                    <immiInput :maxLength="25" :onlyNumbers="true" :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'amountOfMortgageProperty'+cid " :formscope="formscope" v-model="value.amountOfMortgageProperty" :required="true" :fieldName="'amountOfMortgageProperty'+fieldName " label="Amount of Morgage on the property" placeHolder="Amount of Morgage on the property" :tplkey="'amountOfMortgageProperty'"/>
                    <immiInput :notRequired="notRequired" :display="false"  :tplsection="tplsection"  :fieldsArray="fieldsArray"   wrapclass="md:w-1/2" :cid="'addressPropertyIsLocate'+cid " :formscope="formscope" v-model="value.addressPropertyIsLocate" :required="true" :fieldName="'addressPropertyIsLocate'+fieldName " label="Address where the real property is located" placeHolder="Address where the real property is located" :tplkey="'addressPropertyIsLocate'"/>
                </div>
                </div>  
              </div>
            </div>
      </div>
    </div>  
</template>
<script>
import casedocumentslist from "@/views/common/casedocuments.vue";
import immiyesorno from "@/views/forms/fields/yesorno.vue";
import selectField from "@/views/forms/fields/simpleselect.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import datepickerField from "@/views/forms/fields/datepicker.vue";
import Datepicker from "vuejs-datepicker-inv";
import immiswitchyesno from "@/views/forms/fields/switchyesno.vue";
//pass v- model as petition['benificiaryInfo']['financials']
  export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    // provide() {
    //     return {
    //         parentValidator: this.$validator,
    //     };
    // },
    components: { 
      casedocumentslist,
      immiyesorno,
      immiswitchyesno,
      selectField,
      Datepicker, 
      immiInput, 
      datepickerField
    },
    data: () => ({
      benfAdjustmentDocument:[{
        required: false,
        key: 'benfAdjustmentDocument',
        fieldName: 'benfAdjustmentDocument',
        label: 'Copies of most recent bank statement'
      }],
    //  marriedStates:[],
    //  terminatedStates:[],
    //   startEligibleDate: new Date().setFullYear(new Date().getFullYear() - 18),
    //    marriageEndedDueToList:["Divorce","Death","Other"],
    }),
    props:{
      notRequired:{
        type: Boolean,
        default: false,
      },
      tplsection:{
            type: String,
            default: null,
        },
      fieldName:{
            type: String,
            default: ''
        },
      formscope: {
            type: String,
            default: ''
        },
        cid: String,
      value: null,
      petition:{
        type:Object,
        default:null
      },
      fieldsArray:{
        type:Array,
        default:[]
      },
    //   countries:{
    //     type:Array,
    //     default:[]
    //   },
      
      
    },
    mounted(){
      
    },
    methods:{

    }
  };
</script>